/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './index.styl';

import Icon from '../../Icon';

import { COLORS } from '../../../constants/styles';

const Like = ({ active }) => {
  const fill = active ? COLORS.orangePink : COLORS.grayDark;

  return (
    <div styleName="root">
      <div styleName="wrapper">
        <div
          styleName={classNames('outer', {
            'outer--active': active,
          })}
        >
          <Icon
            styleName="inner"
            className={classNames({ dn: !active })}
            style={{ fill }}
            name="heart-filled"
            size={16}
          />
          <Icon
            styleName="inner"
            className={classNames({ dn: active })}
            style={{ fill }}
            name="heart"
            size={16}
          />
        </div>
      </div>
    </div>
  );
};

Like.propTypes = {
  active: PropTypes.bool,
};

export default CSSModules(Like, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Like/index.jsx